import {
  HISTORICO_COL_ALTERACOES,
  HISTORICO_COL_APLICADA,
  HISTORICO_COL_CRIADA,
  HISTORICO_COL_JUSTIFICATIVA,
  HISTORICO_COL_STATUS,
  HISTORICO_COL_USUARIO,
  HISTORICO_FILTRO_STATUS,
  rotuloStatusHistorico,
} from "@/modules/recursos/simulacao";
import type { FilterOption } from "@/ds";

import type { HistoricoDataColumn } from "./types-historico-simulacao-dialog";

export const HISTORICO_EMPTY_NOUN = "simulação";
export const HISTORICO_EMPTY_PLURAL = "simulações";
export const HISTORICO_LOADING_LABEL = "Carregando histórico...";

/** Chave do filtro de status no `FilterPanel`. */
export const HISTORICO_FILTRO_STATUS_KEY = "status";
export const HISTORICO_FILTRO_STATUS_LABEL = HISTORICO_FILTRO_STATUS;

export const HISTORICO_STATUS_OPCOES: FilterOption[] = [
  { label: rotuloStatusHistorico("APLICADA"), value: "APLICADA" },
  { label: rotuloStatusHistorico("APLICADA_PARCIAL"), value: "APLICADA_PARCIAL" },
  { label: rotuloStatusHistorico("DESCARTADA"), value: "DESCARTADA" },
  { label: rotuloStatusHistorico("ARQUIVADA"), value: "ARQUIVADA" },
];

/** As colunas de dados, na ordem da tela; a de ações (lupa) não entra nas Configurações da Tabela. */
export const HISTORICO_COLUMN_KEYS: readonly HistoricoDataColumn[] = [
  "criada",
  "usuario",
  "status",
  "alteracoes",
  "aplicada",
  "justificativa",
];

export const HISTORICO_COLUMNS: {
  key: HistoricoDataColumn;
  header: string;
  minWidth: string;
}[] = [
  { key: "criada", header: HISTORICO_COL_CRIADA, minWidth: "9.5rem" },
  { key: "usuario", header: HISTORICO_COL_USUARIO, minWidth: "9rem" },
  { key: "status", header: HISTORICO_COL_STATUS, minWidth: "8.5rem" },
  { key: "alteracoes", header: HISTORICO_COL_ALTERACOES, minWidth: "7.5rem" },
  { key: "aplicada", header: HISTORICO_COL_APLICADA, minWidth: "9.5rem" },
  { key: "justificativa", header: HISTORICO_COL_JUSTIFICATIVA, minWidth: "10rem" },
];
